import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';

// Lazy load pages for better performance
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Tests = lazy(() => import('../pages/Tests'));
const Schedule = lazy(() => import('../pages/Schedule'));
const Settings = lazy(() => import('../pages/Settings'));

// Loading component
const Loading = () => (
  <View as="div" textAlign="center">
    <Spinner renderTitle="Loading" size="large" />
  </View>
);

const TestTakerRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tests" element={<Tests />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/test-taker" replace />} />
      </Routes>
    </Suspense>
  );
};

export default TestTakerRoutes;
